import { l as f } from "../../../../_virtual/leaflet-src.js";
function t(o) {
  return o.split(" ").filter(Boolean);
}
function n(o, l) {
  t(l).forEach((i) => {
    f.DomUtil.addClass(o, i);
  });
}
function r(o, l) {
  t(l).forEach((i) => {
    f.DomUtil.removeClass(o, i);
  });
}
function c(o, l, i) {
  o != null && i !== l && (l != null && l.length > 0 && r(o, l), i != null && i.length > 0 && n(o, i));
}
export {
  n as addClassName,
  r as removeClassName,
  c as updateClassName
};
